import {
  LayoutDashboard,
  LayoutGrid,
  PenSquare,
  Inbox,
  BarChart3,
  FileText,
  Image,
  Settings,
  Users,
  LogOut,
  Plus,
  Search,
  Bell,
  Smile,
  Paperclip,
  Volume2,
  VolumeX,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  ChevronLeft,
  X,
  Check,
  AlertCircle,
  AlertTriangle,
  PauseCircle,
  Info,
  Calendar,
  Clock,
  Send,
  Eye,
  Trash2,
  Edit3,
  Copy,
  Download,
  Upload,
  Filter,
  MoreHorizontal,
  ExternalLink,
  Link,
  Globe,
  Sparkles,
  Zap,
  Heart,
  MessageCircle,
  Share2,
  Bookmark,
  TrendingUp,
  TrendingDown,
  ArrowUp,
  ArrowDown,
  ArrowRight,
  CornerDownRight,
  RefreshCw,
  Shield,
  CreditCard,
  Moon,
  Sun,
  Languages,
  LayoutList,
  Rss,
  Plug,
  Sparkle,
  KeyRound,
  Building2,
  Lock,
  Tag,
  type LucideIcon,
  Play,
  Video,
  HelpCircle,
  MessageCircleQuestion,
  PartyPopper,
  CalendarRange,
  WandSparkles,
  House,
  Store,
  PanelLeftClose,
  PanelLeftOpen,
} from 'lucide-react';

/** Semantic icon mapping for consistent usage across the app */
export const Icons = {
  // Navigation
  dashboard: LayoutDashboard,
  compose: PenSquare,
  inbox: Inbox,
  analytics: BarChart3,
  templates: FileText,
  media: Image,
  settings: Settings,
  admin: Shield,
  users: Users,
  logout: LogOut,

  // Actions
  add: Plus,
  search: Search,
  notification: Bell,
  smile: Smile,
  attach: Paperclip,
  sound: Volume2,
  soundOff: VolumeX,
  close: X,
  check: Check,
  play: Play,
  video: Video,
  help: HelpCircle,
  send: Send,
  preview: Eye,
  delete: Trash2,
  edit: Edit3,
  copy: Copy,
  download: Download,
  upload: Upload,
  filter: Filter,
  more: MoreHorizontal,
  externalLink: ExternalLink,
  link: Link,
  refresh: RefreshCw,

  // Navigation arrows
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  arrowRight: ArrowRight,
  cornerDownRight: CornerDownRight,

  // Status
  alert: AlertCircle,
  /** At risk: will fail unless someone acts (pre-publish check). */
  warning: AlertTriangle,
  pause: PauseCircle,
  info: Info,

  // Content
  posts: LayoutList,
  feeds: Rss,
  grid: LayoutGrid,
  list: LayoutList,
  calendar: Calendar,
  clock: Clock,
  globe: Globe,
  sparkles: Sparkles,
  zap: Zap,

  // Engagement
  heart: Heart,
  comment: MessageCircle,
  share: Share2,
  bookmark: Bookmark,

  // Trends
  trendUp: TrendingUp,
  trendDown: TrendingDown,

  // Settings
  billing: CreditCard,
  darkMode: Moon,
  lightMode: Sun,
  language: Languages,

  // Manage
  channels: Plug,
  team: Users,
  spark: Sparkle,
  key: KeyRound,
  building: Building2,
  tag: Tag,
  lock: Lock,

  // The weekly plan (Phase 2)
  // Next week's AI-proposed plan: a wand, so it never reads as the Calendar (DS04).
  plan: WandSparkles,
  home: House,
  brand: Store,
  panelCollapse: PanelLeftClose,
  panelExpand: PanelLeftOpen,
  question: MessageCircleQuestion,
  occasion: PartyPopper,
  slot: CalendarRange,
  swap: RefreshCw,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof Icons;
